import axios from 'axios'

const base = '/v2/portal'

export default {
    getNotificationLogsDataSource(params){
        return axios.get(base + '/notification-logs', {params})
            .then(response => {
                return response.data
            })
    },
    getDeviceTokensByPeopleUuid(uuid){
        return axios.get(base + '/peoples/' + uuid + '/device-tokens')
            .then(response => {
                return response.data
            })
    },
    revokeDeviceToken(tokenId){
        return axios.delete(base + '/device-tokens/' + tokenId)
            .then(response => {
                return response.data
            })
    },
    sendTestToDevice(tokenId, formdata){
        return axios.post(base + '/device-tokens/' + tokenId + '/test', formdata)
            .then(response => {
                return response.data
            })
    },
}
